import { useEffect, useRef, useLayoutEffect, useState } from "react"
import { useInstallAnimation, QUALITYSIZE } from "./InstallAnimation"
import { useFrameAnimation } from "./FrameAnimation"
import { mvSubscribe } from "./utils"
import { useEnv } from "contexts/Env"
import { useConfigurator } from "./context"

function trueIndex(v) {
  return v.toString().padStart(3, "0")
}

function initSourceCld(path3d, quality, secureDistribution, catalogueNewPath, catalogYear) {
  return `https://${secureDistribution}/image/upload/${quality}/v1/${catalogueNewPath}/${catalogYear}/360/${path3d}/${path3d}--`
}

function qualityPathCld(s, q) {
  return `w_${s}/q_${q}`
}

function fetchRmc(rmc, path3d, loframes, hiframes, catalogueNewPath, catalogYear, mobile, secureDistribution) {
  let q = Array.from({ length: 2 }).map((v, i) => qualityPathCld(QUALITYSIZE.S.lo[i], QUALITYSIZE.Q.lo[i]))
  const lopath = initSourceCld(path3d, q[mobile], secureDistribution, catalogueNewPath, catalogYear)
  q = Array.from({ length: 2 }).map((v, i) => qualityPathCld(QUALITYSIZE.S.hi[i], QUALITYSIZE.Q.hi[i]))
  const hipath = initSourceCld(path3d, q[mobile], secureDistribution, catalogueNewPath, catalogYear)
  const lodata = loframes.map(v => ({
    rmc: rmc,
    path: `${lopath}${trueIndex(v)}.webp`,
    index: v,
    size: QUALITYSIZE.S.lo[mobile],
  }))
  const hidata = hiframes.map(v => ({
    rmc: rmc,
    path: `${hipath}${trueIndex(v)}.webp`,
    index: v,
    size: QUALITYSIZE.S.hi[mobile],
  }))

  return hidata.concat(lodata)
}

function loadBlob(aborts, credentials) {
  return function (path) {
    const controller = new AbortController()
    aborts.push(controller)
    return fetch(
      new Request(path, {
        credentials: credentials,
        signal: controller.signal,
      })
    )
      .then(r => r.status === 200 && r.blob())
      .then(URL.createObjectURL)
      .catch(e => null)
  }
}

const CCR = 25

export function CfgPreload(props) {
  const { Ctx, ictx } = props
  const { fetching, getModel, mobile, model, startrmc, settled, readyCanvas, launched, credentials } = useFrameAnimation(Ctx)
  const { frames, clearFrames, PARAMS } = useInstallAnimation(ictx)
  const rfaborts = useRef([])
  const env = useEnv()
  const {
    cloudinary: { secureDistribution },
  } = env
  let loaded = useRef(false).current
  const { legal_disclaimer_state } = useConfigurator()

  function settle() {
    settled.set(launched.get() && loaded && readyCanvas.get() && legal_disclaimer_state.get() !== 1 ? 0 : -1)
  }

  async function preload(v) {
    if (v) return
    await kill()
    const m = getModel(startrmc)
    const { loframes, hiframes, range } = PARAMS
    //        console.log("PARAMS", loframes, hiframes, range)
    const all = fetchRmc(m.rmc, m.path3d, loframes.split(","), hiframes.split(","), env.catalogueNewPath, env.catalogYear, mobile.get(), secureDistribution)
    //        console.log("all", all)
    await load(true)
    model.set(startrmc)

    for (let i = 0; i < CCR; i++) {
      load()
    }

    async function load(once) {
      if (!all.length) return
      let { rmc, path, index, size } = all.shift()
      size = frames.current.size > 0 ? size : size * 2 //window.devicePixelRatio
      const bloburl = await loadBlob(rfaborts.current, credentials)(path)
      frames.current.set(+index, {
        src: bloburl,
        size: size,
      })
      if (frames.current.size >= range) {
        loaded = true
        return settle()
      }
      if (!once) load()
    }
  }
  useEffect(() => mvSubscribe(fetching, preload, false), [])

  useEffect(() => mvSubscribe(readyCanvas, settle, false), [])
  useEffect(() => mvSubscribe(launched, settle), [])
  useEffect(() => mvSubscribe(legal_disclaimer_state, settle), [])

  async function kill() {
    await clearFrames()
    return new Promise(resolve => {
      rfaborts.current.forEach(controller => controller.abort())
      resolve()
    })
  }
  useEffect(() => kill, [])

  return null
}
